import { render } from "./BlckSupport.vue?vue&type=template&id=3e1dd7ed"
import script from "./BlckSupport.vue?vue&type=script&lang=js"
export * from "./BlckSupport.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__